export const PROFILE_VERIFIED_TYPES = ['none', 'blue', 'business', 'government'] as const;
